import { AxiosError } from 'axios';
import { PUT_START_FILE_BLACKLIST_PROCESSING } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================

export interface PutStartBlacklistFileProcessingRequest {
  uuid: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: void) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePutStartBlacklistFileProcessing = ({ onSuccess, onError }: Input) => {
  const putStartBlacklistFileProcessing = async (payload: PutStartBlacklistFileProcessingRequest) => {
    await axiosClient.put<undefined>(
      PUT_START_FILE_BLACKLIST_PROCESSING,
      payload
    );
  };

  return useCustomMutation(putStartBlacklistFileProcessing, {
    onSuccess,
    onError,
  });
};
